import React from "react";
import { Layout } from "../layout";
import { Profile } from "../auth";

const Manage = () => {
  return (
    <Layout className="content">
      <Profile />
    </Layout>
  );
};

export default Manage;
